export default "__VITE_ASSET__DwJxavof__"